// The plan amount is stored in cents, so the field label doubles as the dollar
// readout (e.g. "Amount (in cents) = $67.00"). It used to be a separate helper
// line under the input, where it visually collided with the next field's label.
const amountLabel = (amount) => {
	const value = Number(amount);
	if (amount === "" || amount === null || amount === undefined || Number.isNaN(value)) {
		return "Amount (in cents) - e.g. 9700 = $97.00";
	}
	return `Amount (in cents) = $${(value / 100).toFixed(2)}`;
};

export default amountLabel;
